import { ReactElement } from 'react';
import { useInView } from 'react-cool-inview';

import { useTheme, useMediaQuery, Box, Typography } from '@mui/material';

import _ from 'lodash';

import useStyles from './styles';
import { ProductProps } from './types';

import 'imagehover.css/css/imagehover.min.css';

export default function Product(props: ProductProps): ReactElement {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));

  const style = useStyles();

  const { children, label, image, hash, color } = props;

  const { observe, inView } = useInView({
    rootMargin: '-50% 0px'
  });

  return (
    <Box
      ref={observe}
      id={hash}
      key={label}
      sx={{
        ..._.merge(style.product, style[hash]),
        borderColor: 'divider'
      }}>
      <Box component='figure' className='imghvr-fade' sx={{ ...style.figure }}>
        {image}

        {isXs ? (
          <figcaption className='ih-fade-up' style={{ opacity: inView ? 1 : 0 }}>
            {children}
          </figcaption>
        ) : (
          <figcaption className='ih-fade-up'>{children}</figcaption>
        )}
      </Box>

      <Typography align='center' color='initial' variant='h5' sx={{ color: `${color}.main` }}>
        {label}
      </Typography>
    </Box>
  );
}
